import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export default [{
  path: "/storeApply",
  name: "storeApplyNew",
  component: function component() {
    return import("@/views/store-apply/index.vue");
  },
  meta: {
    title: "商家入驻首页",
    foot: true
  }
}, {
  path: "/storeApply/merchantInfo/:channelType",
  name: "storeApplyMerchantInfo",
  component: function component() {
    return import("@/views/store-apply/mechant-info.vue");
  },
  meta: {
    title: "提交信息",
    foot: true
  }
}, {
  path: "/storeApply/realNameAuth",
  name: "storeApplyRealNameAuth",
  component: function component() {
    return import("@/views/store-apply/real-name-auth.vue");
  },
  meta: {
    title: "实名认证",
    foot: true
  }
}];